var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnyataLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 30,
    viewBox: "0 0 44 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0314 13.7517C15.0314 14.0346 15.2616 14.2649 15.5442 14.2544C22.623 13.991 28.3158 8.29847 28.5792 1.21993C28.5897 0.937241 28.3594 0.707031 28.0765 0.707031H15.5436C15.2607 0.707031 15.0314 0.936351 15.0314 1.21923V13.7517Z",
    fill: "#3E7EEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.512201 15.8185C0.22932 15.8185 -0.000991913 16.0487 0.00952716 16.3314C0.272929 23.41 5.96567 29.1025 13.0445 29.3659C13.3271 29.3764 13.5573 29.1461 13.5573 28.8632V16.3307C13.5573 16.0478 13.328 15.8185 13.0451 15.8185H0.512201Z",
    fill: "#3E7EEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5442 15.8281C15.2616 15.8175 15.0314 16.0478 15.0314 16.3307V28.8632C15.0314 29.1461 15.2607 29.3754 15.5436 29.3754H28.0762C28.3592 29.3754 28.5896 29.145 28.5789 28.8622C28.3114 21.7838 22.6227 16.0914 15.5442 15.8281Z",
    fill: "#3E7EEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00952714 13.751C-0.000991919 14.0337 0.22932 14.2639 0.512201 14.2639H13.0451C13.328 14.2639 13.5573 14.0346 13.5573 13.7517V1.21923C13.5573 0.936352 13.3271 0.706039 13.0445 0.716557C5.96567 0.979941 0.272929 6.67248 0.00952714 13.751Z",
    fill: "#3E7EEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4898 0.707031C30.2069 0.707031 29.9766 0.937241 29.9871 1.21993C30.2505 8.29847 35.9432 13.991 43.022 14.2544C43.3047 14.2649 43.5349 14.0346 43.5349 13.7517V1.21923C43.5349 0.936352 43.3056 0.707031 43.0227 0.707031H30.4898Z",
    fill: "#3E7EEE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9871 28.8625C29.9766 29.1452 30.2069 29.3754 30.4898 29.3754H43.0227C43.3056 29.3754 43.5349 29.1461 43.5349 28.8632V16.3307C43.5349 16.0478 43.3047 15.8175 43.022 15.8281C35.9432 16.0914 30.2505 21.784 29.9871 28.8625Z",
    fill: "#3E7EEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnyataLogo);
export default __webpack_public_path__ + "static/media/enyataLogo.bcd29dbd0767f109dc10b6f7f56ab88e.svg";
export { ForwardRef as ReactComponent };